import React from 'react';

export default function JoinDoorIcon(props) {
  return (
    <svg
      {...props}
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.66663 5.66667V2.33333C9.66663 1.59733 10.264 1 11 1H19.6666C20.4026 1 21 1.59733 21 2.33333V17.6667C21 18.4027 20.4026 19 19.6666 19H11C10.264 19 9.66663 18.4027 9.66663 17.6667V14.3333"
        stroke="#474747"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33337 13.6667L9.00004 10L5.33337 6.33337"
        stroke="#474747"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 10H1"
        stroke="#474747"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7241 1.53064L16.2961 4.27597C15.9041 4.51864 15.6654 4.94797 15.6654 5.40931V14.592C15.6654 15.0533 15.9041 15.4813 16.2961 15.7253L20.7254 18.472"
        stroke="#474747"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
